import { sendGAEvent } from '../utils';

export enum EBonusShopEvents {
  PRODUCT_DETAILS_APPEARANCE = 'bonus_shop_prod_details_apprearance',
  EXCHANGE_SUCCESS = 'bonus_shop_exchange_success',
  EXCHANGE_FAILURE = 'bonus_shop_exchange_failure',
}

const EVENT_CATEGORY = 'bonusShopEvents';

export interface IBonusShopExchangeEvent {
  type: string;
  bonus_id: string;
  fs_amount?: number;
  amount?: number;
  currency: string;
  cp_price: number;
}

interface IBonusShopProductDetailsEvent extends IBonusShopExchangeEvent {
  cp_balance: number;
}

interface IBonusShopExchangeFailureEvent extends IBonusShopExchangeEvent {
  error: string;
}

export const sendBonusShopProductDetailsEvent = (
  data: IBonusShopProductDetailsEvent
) => {
  sendGAEvent(EBonusShopEvents.PRODUCT_DETAILS_APPEARANCE, {
    event_category: EVENT_CATEGORY,
    ...data,
  });
};

export const sendBonusShopExchangeSuccessEvent = (
  data: IBonusShopExchangeEvent
) => {
  sendGAEvent(EBonusShopEvents.EXCHANGE_SUCCESS, {
    event_category: EVENT_CATEGORY,
    ...data,
  });
};

export const sendBonusShopExchangeFailureEvent = (
  data: IBonusShopExchangeFailureEvent
) => {
  sendGAEvent(EBonusShopEvents.EXCHANGE_FAILURE, {
    event_category: EVENT_CATEGORY,
    ...data,
  });
};
